import { useCallback, useEffect, useState } from 'react';

let interval = 0;
export const useCounterDown = () => {
  const [remainSeconds, setRemainSeconds] = useState(-1);
  const [isStartCount, setIsStartCount] = useState(false);

  const startCountDown = useCallback((timeSecond: number) => {
    setRemainSeconds(timeSecond);
    setIsStartCount(true);
  }, []);

  const stopCountDown = useCallback(() => {
    setRemainSeconds(-1);
    setIsStartCount(false);
  }, []);

  useEffect(() => {
    if (isStartCount) {
      clearInterval(interval);
      interval = setInterval(() => {
        setRemainSeconds((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
          }
          return prev - 1;
        });
      }, 1000) as any;
      setIsStartCount(false);
    }
  }, [isStartCount]);

  return {
    remainSeconds,
    startCountDown,
    stopCountDown,
  };
};
